// UI-only option of the executor filter of the request list; it is sent to the backend as `null` and matches
// the requests nobody is assigned to.
export const REQUEST_WITHOUT_EXECUTOR = 'WITHOUT_EXECUTOR';
